module.exports = __webpack_public_path__ + "static/media/1 19 hjerne.d50d8ea0.mp3";